// extracted by mini-css-extract-plugin
export default {"chat-container":"NutriBot_chat-container__mYJdP","input-container":"NutriBot_input-container__oKmso","loading-icon":"NutriBot_loading-icon__muh2j","spin":"NutriBot_spin__30wgJ"};